import axios from '@/utils/api-axios'
import {
  SET_CONFIGURACAO
} from '../mutation-types'

const state = {
  configuracoes: []
}

const getters = {
  configuracoes: state => state.configuracoes
}

const mutations = {
  [SET_CONFIGURACAO] (state, payload) {
    state.configuracoes = payload
  }
}

const actions = {
  async getConfiguracao ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `configuracao`
    })
    commit(SET_CONFIGURACAO, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/configuracao.js